import { PermissoesPasta } from '@/core/enums/permissoes-pasta'
import { downloadByButton } from '@/core/components/uploader-utils'

export function download(generateDownloadLink, { id }) {
  generateDownloadLink({
    variables: { id }
  }).then(({ data: { gerarLinkDownloadByItemBiblioteca: link } }) => {
    downloadByButton(link)
  })
}

export function hasWritePermission(item) {
  const { permissoesAcessoUsuarioLogado = [] } = item || {}
  const ids = permissoesAcessoUsuarioLogado.map(obj => obj.id)

  return ids.indexOf(PermissoesPasta.LEITURA_ESCRITA) > -1
}
